import { render, staticRenderFns } from "./FinancialConsulting.vue?vue&type=template&id=1da1a8da&scoped=true&"
import script from "./FinancialConsulting.vue?vue&type=script&lang=js&"
export * from "./FinancialConsulting.vue?vue&type=script&lang=js&"
import style0 from "./FinancialConsulting.vue?vue&type=style&index=0&id=1da1a8da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1a8da",
  null
  
)

export default component.exports